
// Home

export function pendingEnquiries(data) {
    return (
        {
            "pageNo": data.pageNo,
            "size": data.size ? data.size : 12,
            "sortFilter": {
                "createdAt": "-1"
            },
            "filter": {
                "status-id": "PENDING",
                "$or":[{stock:{$exists:false}},{stock:0}],//SL-702 Seller Stock
                ...data.dates
            },
            "excludeField": {}
        }
    )
}

function newOrders(data) {
    return (
        {
            "pageNo": data.pageNo,
            "size": 12,
            "sortFilter": {
                "createdAt": 1
            },
            "filter": {
                "status": {
                    "$in": [
                        "ASSIGN",
                        "DOWNLOAD"
                    ]
                }
            },
            "excludeField": {}
        }
    )
}

function sortdateweb(data, sort) {
    return (
        {
            "pageNo": data.pageNo,
            "size": 12,
            "sortFilter": {
                "createdAt": sort
            },
            "filter": {
                "status": {
                    "$in": [
                        "ASSIGN",
                        "DOWNLOAD",
                        "PICKED",
                        "DELIVERED",
                        "CANCEL",
                        "REVOKED"
                    ]
                }
            },
            "excludeField": {}
        }
    )
}


function allOrdersWeb(data) {
    return (
        {
            "pageNo": data.pageNo,
            "size": data.size ? data.size : 12,
            "sortFilter": {
                "createdAt": -1
            },
            "filter": {
                "status": {
                    "$in": [
                        "ASSIGN",
                        "DOWNLOAD",
                        "PICKED",
                        "DELIVERED",
                        "CANCEL",
                        "REVOKED"
                    ]
                }
            },
            "excludeField": {}
        }
    )
}

// Cancelled orders


function cancelledOrders(data) {
    return (
        {
            "pageNo": data.pageNo,
            "size": data.size ? data.size : 12,
            "sortFilter": {
                "createdAt": -1
            },
            "filter": {
                "status": {
                    "$in": [
                        "CANCEL",
                        "REVOKED"
                    ]
                }
            },
            "excludeField": {}
        }
    )
}



// Delivered orders


function deliveredOrders(data) {
    return (
        {
            "pageNo": data.pageNo,
            "size": data.size ? data.size : 12,
            "sortFilter": {
                "createdAt": -1
            },
            "filter": {
                "status": {
                    "$in": [
                        "DELIVERED"
                    ]
                }
            },
            "excludeField": {}
        }
    )
}


// Intransit(Picked) Orders

function inTransitOrders(data) {
    return (
        {
            "pageNo": data.pageNo,
            "size": data.size ? data.size : 12,
            "sortFilter": {
                "createdAt": -1
            },
            "filter": {
                "status": {
                    "$in": [
                        "PICKED"
                    ]
                }
            },
            "excludeField": {}
        }
    )
}

// set api body
function approvedProductsOpp(data) {
    return (
        {
            "pageNo": data.pageNo,
            "size": data.size ? data.size : 20,
            "sortFilter": {
                "vendors.updated_at": -1
            },
            "filter": {
                ...data.filters,
                // "vendors": {
                //     "$elemMatch": {
                //         "$and": [
                //             {
                //                 vActive: { $exists: true },
                //             },
                //             {
                //                 ...data.orCondt,
                //             },
                //             {
                //                 ...data.status
                //             },
                //             {
                //                 ...data.prStatus
                //             },
                //             {
                //                 vActive: { $ne: "REJECT" }
                //             }
                //         ]
                //     }
                // }
            },
            "excludeField": {},
            "productId": data?.productId,//SL-675
            "searchIds": data?.searchIds//SL-675
        }
    )
}

const inventoryDefaultSelectFields = {
    "SKU": 1,
    "attributeList": 1,
    "categories": 1,
    "combination": 1,
    "createdDate": 1,
    "description": 1,
    "descriptionNew": 1,
    "displayActualPrice": 1,
    "images": 1,
    "lowestPkgs": 1,
    "manufacturer": 1,
    "pkgs": 1,
    "price": 1,
    "productName": 1,
    "product_type": 1,
    "quantity": 1,
    "rating": 1,
    "ratingCount": 1,
    "reviews": 1,
    "selfShip": 1,
    "sellerRatings": 1,
    "sellerRemarksHistory": 1,
    "shortDescription": 1,
    "specificationNew": 1,
    "specificationOld": 1,
    "taxClass": 1,
    "tmpSts": 1,
    "urlKey": 1,
    "vendorAddDate": 1,
    "vendors": 1,
    "videos": 1,
    "weight": 1,
    "_id": 1
};

const inventoryDefaultFieldFilters = {
    
};

const buildInventorySelectFields = (selectFields = {}) => ({
    ...inventoryDefaultSelectFields,
    ...selectFields
});

const buildInventoryFieldFilters = (fieldFilters = {}) => ({
    ...inventoryDefaultFieldFilters,
    ...fieldFilters,
    images: {
        ...inventoryDefaultFieldFilters.images,
        ...(fieldFilters.images || {})
    }
});

function approvedProducts(data) {

    const mConditions = [
        { active: true },
        { vActive: { $exists: true } },

        data.orCondt,
        data.status,
        data.prStatus,
        data.hsnFilter,

        { vActive: { $ne: "REJECT" } },
        data.saleFilter,

    ].filter(
        (item) => item && Object.keys(item).length > 0
    );

    return {
        pageNo: data.pageNo,

        size: data.size ? data.size : 12,

        sortFilter: {
            "vendors.updated_at": -1
        },

        filter: {
            ...data.filters,

            vendors: {
                $elemMatch: {
                    $and: mConditions
                }
            }
        },

        excludeField: {},

        fieldFilters: buildInventoryFieldFilters(data?.fieldFilters),

        selectFields: buildInventorySelectFields(data?.selectFields),

        productId: data?.productId,

        searchIds: data?.searchIds
    };
}
export function searchVendProducts(data) {
    return (
        {
            "pageNo": data.pageNo,
            "size": data.size ? data.size : 12,
            "sortFilter": {
                "vendors.updated_at": -1
            },
            "filter": {
                ...data.filters,
                // "vendors": {
                //     "$elemMatch": {
                //         "$and": [
                //             {
                //                 vActive: { $exists: true },
                //             },
                //             {
                //                 ...data.orCondt,
                //             },
                //             {
                //                 ...data.status
                //             },
                //             {
                //                 ...data.prStatus
                //             },
                //             {
                //                 vActive: { $ne: "REJECT" }
                //             }
                //         ]
                //     }
                // }
            },
            "excludeField": {}
        }
    )
}
export function approvedOrProducts(data) {
    return (
        {
            "pageNo": data.pageNo,
            "size": data.size ? data.size : 12,
            "sortFilter": {
                "vendors.updated_at": -1
            },
            "filter": {
                ...data.filters,
                "vendors": {
                    "$elemMatch": {
                        "$or": [
                            {
                                "$and": [
                                    {
                                        vActive: { $exists: true }
                                    },
                                    {
                                        vActive: { $ne: "REJECT" }
                                    },
                                    {
                                        ...data.status
                                    },
                                    {
                                        ...data.orCondt
                                    },
                                ]
                            },
                            {
                                "$and": [
                                    {
                                        vActive: { $exists: true }
                                    },
                                    {
                                        vActive: { $ne: "REJECT" }
                                    },
                                    {
                                        ...data.prStatus
                                    },
                                    {
                                        ...data.orCondt
                                    }
                                ]
                            },
                            {
                                "$and": [
                                    {
                                        vActive: { $exists: true }
                                    },
                                    {
                                        vActive: { $ne: "REJECT" }
                                    },
                                    {
                                        ...data.weightStatus
                                    },
                                    {
                                        ...data.orCondt
                                    }
                                ]
                            }
                            // {
                            //     ...data.status
                            // },
                            // {
                            //     ...data.prStatus
                            // },
                            // {
                            //     ...data.weightStatus
                            // }
                        ],
                        ...data.hsnFilter
                    }
                }
            },
            "excludeField": {},
            "productId": data?.productId,//SL-675
            "searchIds": data?.searchIds//SL-675
        }
    )
}

export function weightVerification(data) {
    return (
        {
            "pageNo": data.pageNo,
            "size": data.size ? data.size : 12,
            "sortFilter": {
                "vendors.updated_at": -1
            },
            "filter": {
                ...data.filters,
                "vendors": {
                    "$elemMatch": {
                        "$and": [
                            {
                                vActive: { $exists: true }
                            },
                            {
                                vActive: { $ne: "REJECT" }
                            },
                            {
                                ...data.weightStatus
                            },
                            {
                                ...data.orCondt
                            },
                            // l1-2319 (2-9-26)
                            {
                                ...data.hsnFilter
                            }
                        ],
                        // "$or": [
                        //     {
                        //         ...data.status
                        //     },
                        //     {
                        //         ...data.weightStatus
                        //     }
                        // ]
                    }
                }
            },
            "excludeField": {},
            "productId": data?.productId,//SL-675
            "searchIds": data?.searchIds//SL-675
        }
    )
}

// {vendors: {$elemMatch: {$and: [{vActive: {$exists: true}}, {vActive: {$ne: "REJECT"}}]}}}

function pendforapprovProducts(data) {
    return (
        {
            "pageNo": data.pageNo,
            "size": data.size ? data.size : 12,
            "sortFilter": {
                "updatedAt": -1
            },
            "filter": {
                "status": "PENDING"
            },
            "productFilter": data.productFilters,
            "excludeField": {}
        }
    )
}

function draftedProdInitialCount(data) {
    return (
        {
            "pageNo": data.pageNo,
            "size": data.size ? data.size : 12,
            "sortFilter": {
                "updatedAt": -1
            },
            "filter": {
                ...data.filters
            },
            "productFilter": {

            },
            "excludeField": {

            }
        }
    )
}

export function enquiryHistory(data) {
    return (
        {
            "pageNo": data.pageNo,
            "size": 12,
            "sortFilter": {
                "updatedAt": -1
            },
            "filter": {
                "status": {
                    "$in": [
                        "APPROVED",
                        "DISAPPROVED",
                        "EXPIRED"
                    ]
                },
                ...data.dates
            },


            "excludeField": {}
        }
    )
}

function orderHistory(data) {
    return (
        {
            "pageNo": data.pageNo,
            "size": 12,
            "sortFilter": {
                "createdAt": -1
            },
            "filter": {
                "status": {
                    "$in": [
                        "PICKED",
                        "DELIVERED",
                        "CANCEL",
                        "REVOKED"
                    ]
                }
            },


            "excludeField": {}
        }
    )
}

function negotiationReq(data) {
    return (
        {
            "pageNo": data.pageNo,
            "size": 12,
            "sortFilter": {
                "updatedAt": -1
            },
            "filter": {
                "status": {
                    "$in": [
                        "NEGOTIATE"
                    ]
                }
            },


            "excludeField": {}
        }
    )
}

function pendingProducts(data) {
    return (
        {
            "pageNo": data.pageNo,
            "size": data.size ? data.size : 12,
            "sortFilter": {
                "updatedAt": -1
            },
            "filter": {
                ...data.filters
            },
            "productFilter": {

            },
            "excludeField": {

            }
        }
    )
}

function draftedProducts(data) {
    return (
        {
            "pageNo": data.pageNo,
            "size": data.size ? data.size : 12,
            "filter": {
                ...data.filters
            },
            "productFilter": {

            },
            "excludeField": {

            }
        }
    )
}

function rejectedProducts(data) {
    return (
        {
            "pageNo": data.pageNo,
            "size": data.size ? data.size : 12,
            "sortFilter": {
                "updatedAt": -1
            },
            "productFilter": data.productFilters,
            "filter": {
                "status": "REJECTED"
            },
            "excludeField": {}
        }
    )
}

function pendingFromSellerProducts(data) {
    return (
        {
            "pageNo": data.pageNo,
            "size": data.size ? data.size : 12,
            "sortFilter": {
                "createdDate": -1
            },
            "filter": {
                ...data.filters,
                "tmpSts": {
                    "$in": data?.tmpSts
                },
            },
            "excludeField": {}
        }
    )
}

function pendingFromSellerProductsWithourRejected(data) {
    return (
        {
            "pageNo": data.pageNo,
            "size": data.size ? data.size : 12,
            "sortFilter": {
                "createdDate": -1
            },
            "filter": {
                ...data.filters,
                "tmpSts": {
                    "$in": ["forwarded-to-seller"]
                },
            },
            "excludeField": {}
        }
    )
}

function categoryProductList(data) {
    return (
        {
            "pageNo": data.pageNo,
            "size": 15,
            "filter": {
                "categories-objectId": data.categoryId,
                "vendors": data.vendors,
            },
            "sortFilter": {
                "completeSellOrderCount": -1,  // 2nd: total orders all time  ← MISSING
                "productViewCount": -1,        // 3rd: most viewed            ← WRONG POSITION
                "displayActualPrice": -1        // 4th: lowest price           ← was 2nd before
            },
            "excludeField": {

            }
        }
    )
}

// Filters
// Enquiry


export function filterenquiry(data, filters, dates) {
    if (dates) {
        return (
            {
                "pageNo": data.pageNo,
                "size": 12,
                "sortFilter": {
                    "createdAt": -1
                },
                "filter": {
                    "status": {
                        "$in":
                            filters
                    },
                    "from-createdAt": dates.from + 'T00:00:00',
                    "to-createdAt": dates.to + 'T23:59:59'
                },


                "excludeField": {}
            }
        )
    }
    else {
        return (
            {
                "pageNo": data.pageNo,
                "size": 12,
                "sortFilter": {
                    "createdAt": -1
                },
                "filter": {
                    "status": {
                        "$in":
                            filters
                    }
                },


                "excludeField": {}
            }
        )
    }
}

// Orders


export function revokedOnlyOld(data) {
    let sortFilt;
    if (data.sortFilter) {
        sortFilt = data.sortFilter
    }
    else {
        sortFilt = { "orderPlaceDate": -1 }
    }
    return (
        {
            "pageNo": data.pageNo,
            "size": data.size ? data.size : 12,
            "sortFilter": sortFilt,
            "filter": {
                // "products.tracks.docketStatus-id": "Returned",
                ...data.filters,
                ...data.spclFilter
            },


            "excludeField": {
                "orderId": 1,
                "products.quantity": 1,
                "products.productId.images": 1,
                "products.productId.productName": 1,
                "products.productId.SKU": 1,
                "products.tracks": 1,
                "products.rtoReportId": 1,
                "products.vendorDetails": 1,
                "updatedAt": 1,
                "createdAt": 1,
                "orderPlaceDate": 1,
                "deliveryDate": 1,
                "rtoDate":1,//S:-766 RTO Missing Date,
                "products.productId.urlKey": 1 //SL-866
            },
            "productId": false,//SL-675
            //"productId": data?.searchIds, //SL-675
            "searchIds": data?.searchIds//SL-675

        }
    )
}

export function revokedOnly(data) {
    let sortFilt;
    if (data.sortFilter) {
        sortFilt = data.sortFilter
    }
    else {
        sortFilt = { "orderPlaceDate": -1 }
    }
    
    // Build filter
    let filter = {
        ...data.filters,
        ...data.spclFilter
    };
    
    // If searchIds are product IDs, add to filter
    if (data?.searchIds?.length) {
        filter['products.productId._id'] = { $in: data.searchIds };
    }
    
    return (
        {
            "pageNo": data.pageNo,
            "size": data.size ? data.size : 12,
            "sortFilter": sortFilt,
            "filter": filter,
            "excludeField": {
                "orderId": 1,
                "products.quantity": 1,
                "products.productId.images": 1,
                "products.productId.productName": 1,
                "products.productId.SKU": 1,
                "products.tracks": 1,
                "products.rtoReportId": 1,
                "products.vendorDetails": 1,
                "updatedAt": 1,
                "createdAt": 1,
                "orderPlaceDate": 1,
                "deliveryDate": 1,
                "rtoDate": 1,
                "products.productId.urlKey": 1,
                "slNotes": 1,
                "status":1
            },
            "productId": false
            // Remove searchIds from here
        }
    )
}

// me
export function meOnly(data) {
    return (
        {

            "excludeField": {
                ...data.excludeField
            }
        }
    )
}

export function orderRevoke(data) {
    return (
        {
            "size": data.size ? data.size : 12,
            "pageNo": data.pageNo,
            "sortFilter": {
                "createdAt": -1
            },
            "filter": {
                "status-id": "REVOKED", "rClk": { "$ne": true }
            },
            "excludeField": {}
        }
    )
}


function filterOrdersdatefilter(data, filters, dates) {
    return (
        {
            "pageNo": data.pageNo,
            "size": 12,
            "sortFilter": {
                "createdAt": -1
            },
            "filter": {
                "status": {
                    "$in":
                        filters
                },
                "from-updatedAt": dates.from + 'T00:00:00',
                "to-updatedAt": dates.to + 'T23:59:59'
            },


            "excludeField": {}
        }
    )
}

function filterOrdersdate(data, dates) {
    return (
        {
            "pageNo": data.pageNo,
            "size": 12,
            "sortFilter": {
                "createdAt": -1
            },
            "filter": {
                "status": {
                    "$in": [
                        "ASSIGN",
                        "DOWNLOAD",
                        "PICKED",
                        "DELIVERED",
                        "CANCEL",
                        "REVOKED"
                    ]
                },
                "from-updatedAt": dates.from + 'T00:00:00',
                "to-updatedAt": dates.to + 'T23:59:59'

            },


            "excludeField": {}
        }
    )
}

function filterOrdersfilter(data, filters) {
    return (
        {
            "pageNo": data.pageNo,
            "size": data.size ? data.size : 12,
            "sortFilter": {
                "createdAt": -1
            },
            "filter": {
                "status": {
                    "$in":
                        filters
                }

            },


            "excludeField": {}
        }
    )
}

export function filterOrders(data) {
    return (
        {
            "pageNo": data.pageNo,
            "size": data.size || 12,
            "sortFilter": data.sortFilter || {
                "createdAt": -1
            },
            "orderFilter": data.orderFilter,
            "filter": {
                "status": {
                    "$in":
                        data.statusFilter
                },
                ...data.dates,
                ...data.filters
            },
            "excludeField": {},
            "productId": data?.productId,//SL-675
            "searchIds": data?.searchIds//SL-675
        }
    )
}


// Search Records
// Enquiries

export function searchnewenquiry(data, productName, type = null) {
    let orderFilter = { "products.productId.productName": productName };
    if (type == 'sku') {
        orderFilter = { "products.productId.SKU": productName };
    }
    return (
        {
            "pageNo": data.pageNo,
            "size": 12,
            "orderFilter": { ...orderFilter },
            "sortFilter": {
                "createdAt": -1
            },
            "filter": {
                "status": {
                    "$in": [
                        "PENDING"
                    ]
                }
            },


            "excludeField": {}
        }
    )
}

export function searchenquiryHistory(data, productName, type) {
    let orderFilter = { "products.productId.productName": productName };
    if (type == 'sku') {
        orderFilter = { "products.productId.SKU": productName };
    }
    return (
        {
            "pageNo": data.pageNo,
            "size": 12,
            "orderFilter": { ...orderFilter },
            "sortFilter": {
                "createdAt": -1
            },
            "filter": {
                "status": {
                    "$in": [
                        "APPROVED",
                        "DISAPPROVED",
                        "EXPIRED"
                    ]
                }
            },


            "excludeField": {}
        }
    )
}

// Products
function searchapprovedProduct(data, productName) {
    return (
        {
            "pageNo": data.pageNo,
            "size": 12,
            "sortFilter": {

            },
            "filter": {
                "productName": productName,
                "vendors": {
                    "$elemMatch": {
                        "$and": [
                            {
                                vActive: { $exists: true }
                            },
                            {
                                vActive: { $ne: "REJECT" }
                            }
                        ]
                    }
                }
            },


            "excludeField": {}
        }
    )
}


function searchOrders(data, productName, dates) {
    return (
        {
            "pageNo": data.pageNo,
            "size": 12,
            "orderFilter": { "products.productId.productName": productName },
            "sortFilter": {

            },
            "filter": {
                "status": {
                    "$in": [
                        "ASSIGN",
                        "DOWNLOAD"
                    ]
                }
            },


            "excludeField": {}
        }
    )
}

// Order Hist Search

function searchOrdersHist(data, productName) {
    return (
        {
            "pageNo": data.pageNo,
            "size": 12,
            "orderFilter": { "products.productId.productName": productName },
            "sortFilter": {
                "createdAt": -1
            },
            "filter": {
                "status": {
                    "$in": [
                        "PICKED",
                        "DELIVERED",
                        "CANCEL",
                        "REVOKED"
                    ]
                }
            },


            "excludeField": {}
        }
    )
}

function searchOrdersWeb(data, orderName, dates) {
    if (!dates) {
        return (
            {
                "pageNo": data.pageNo,
                "size": 12,
                "orderFilter": { "products.productId.productName": orderName },
                "sortFilter": {
                    "createdAt": -1
                },
                "filter": {
                    "status": {
                        "$in": [
                            "ASSIGN",
                            "DOWNLOAD",
                            "PICKED",
                            "DELIVERED",
                            "CANCEL",
                            "REVOKED"
                        ]
                    }
                },
                "excludeField": {}
            }
        )
    }
    else {
        return (
            {
                "pageNo": data.pageNo,
                "size": 12,
                "orderFilter": { "products.productId.productName": orderName },
                "sortFilter": {
                    "createdAt": -1
                },
                "filter": {
                    "status": {
                        "$in": [
                            "ASSIGN",
                            "DOWNLOAD",
                            "PICKED",
                            "DELIVERED",
                            "CANCEL",
                            "REVOKED"
                        ]
                    },
                    "from-createdAt": dates.from + 'T00:00:00',
                    "to-createdAt": dates.to + 'T23:59:59'
                },
                "excludeField": {}
            }
        )
    }

}

function searchOrdersnameWebFilter(data, orderName, filter, dates) {
    if (!dates) {
        return (
            {
                "pageNo": data.pageNo,
                "size": 12,
                "orderFilter": { "products.productId.productName": orderName },
                "sortFilter": {
                    "createdAt": -1
                },
                "filter": {
                    "status": {
                        "$in": filter
                    }
                },
                "excludeField": {}
            }
        )
    }
    else {
        return (
            {
                "pageNo": data.pageNo,
                "size": 12,
                "orderFilter": { "products.productId.productName": orderName },
                "sortFilter": {
                    "createdAt": -1
                },
                "filter": {
                    "status": {
                        "$in": filter
                    },
                    "from-createdAt": dates.from + 'T00:00:00',
                    "to-createdAt": dates.to + 'T23:59:59'
                },
                "excludeField": {}
            }
        )
    }

}

function searchOrdersWebId(orderId) {
    return (
        {
            "pageNo": 1,
            "size": 12,
            "sortFilter": {
                "purchase_price": -1

            },
            "filter": {

            },
            "orderFilter": { "orderId": orderId },

            "excludeField": {}
        }
    )
}

function searchOrdersWebIdFilter(orderId, filter) {
    return (
        {
            "pageNo": 1,
            "size": 12,
            "sortFilter": {
                "purchase_price": -1

            },
            "filter": {
                "status": {
                    "$in":
                        filter
                }
            },
            "orderFilter": { "orderId": orderId },

            "excludeField": {}
        }
    )
}

function searchNegreq(data, productName) {
    return (
        {
            "pageNo": data.pageNo,
            "size": 12,
            "orderFilter": { "products.productId.productName": productName },
            "sortFilter": {

            },
            "filter": {
                "status": {
                    "$in": [
                        "NEGOTIATE"
                    ]
                }
            },


            "excludeField": {}
        }
    )

}

// Question answer Section

function fetchQA(data) {
    return (
        {
            "pageNo": data.pageNo,
            "size": 12,
            "sortFilter": {
                "_id": 1
            },
            "filter": {
                "active": true,
            },
            "productFilter": {

            },
            "excludeField": {}
        }
    )
}


function fetchansQA(data) {
    return (
        {
            "pageNo": data.pageNo,
            "size": 12,
            "sortFilter": {
                "_id": 1
            },
            "filter": {
                "active": true,
                "answers.email": data.email
            },
            "productFilter": {

            },
            "excludeField": {}
        }
    )
}

function fetchunansQA(data) {
    return (
        {
            // "pageNo": data.pageNo,
            // "size": 12,
            // "sortFilter": {
            //     "_id": 1
            // },
            // "filter": {
            //     "active": true,
            //     // "answers.email": { $ne: data.email },
            //     "answers.sellerId-objectId":{$ne:data.vendorId}
            // },
            // "productFilter": {
            //     "_id-objectId":data.vendorId
            // },
            // "excludeField": {}
            "questionType": data.type,
            "pageNo": data.pageNo,
            "size": data.size ? data.size : 12,
            "sortFilter": {
                "_id": -1
            },
            "filter": {
            },
            "productFilter": {}
        }
    )
}

function fetchIgnoredQA(data) {
    return (
        {
            "pageNo": data.pageNo,
            "size": 12,
            "sortFilter": {
                "_id": 1
            },
            "filter": {
                "active": true,
                "answers.email": { $ne: data.email },
                // "answers.sellerId-objectId":'5f8ee59246075630d7f653fe',
                "answer.questionStatus": "IGNORED"
                // "answers.sellerId-objectId":{$ne:data.vendorId}
            },
            "productFilter": {
                "_id-objectId": data.vendorId
            },
            "excludeField": {}
        }
    )
}



// Notify Section

function fetchAllNotifications(data) {
    return (
        {
            "filter": {
                ...data.filters
            },
            "pageNo": data.pageNo,
            "size": data.size || 12
        }
    )
}

// Fetch reviews

function fetchReviewsData(data) {
    return ({
        "filter": {
            ...data.filter
        },
        "productFilter": {},
        "excludeField": {},
        "pageNo": data.pageNo,
        "size": data.size || 12,
        "sortFilter": data.sortFilter || { "_id": -1 }
    }

    )
}

// Fetch qa for product details

function fetchQaPdetail(data) {
    return (
        {
            "filter": { "active": true, "productId": data.pId },
            "sortFilter": { "last_answer": -1 },
            "pageNo": data.pageNo,
            "size": 12
        }
    )
}

// Fetch reviews for product details

function fetchReviewPdetail(data) {
    return (
        {
            "filter": { "status": true, "productId": data.pId },
            "sortFilter": { "_id": -1 },
            "pageNo": data.pageNo,
            "size": 12
        }
    )
}

// Fetch pDetail for pDetail Page


function pdetailData(data) {
    return (
        {
            "pageNo": 1,
            "size": 12,
            "sortFilter": {
                "vendors.updated_at": -1
            },
            "filter": {
                "_id-objectId": data.pId
            },

            "excludeField": {

            },
            "fieldFilters": buildInventoryFieldFilters(data?.fieldFilters),
            "selectFields": buildInventorySelectFields(data?.selectFields),
        }
    )
}


// Get manufacturers

function searchManufacturers(name,filters) {
    return (
        {

            "filter": {
                "name": name,
                ...filters
            },

        }
    )
}


// Transfer price related

// Transfer price history

function transferPriceHistory(data) {
    if (data.url) {
        return (
            {
                "pageNo": data.pageNo,
                "size": 10,
                "filter": {
                    "product-objectId": data.selectedId,
                    "url-Id": data.url
                },
                "productFilter": {},
                "vendorFilter": {},
                "excludeField": {},
                "columnName": "createdAt",
                "columnValue": -1
            }
        )
    }
    else {
        return (
            {
                "pageNo": data.pageNo,
                "size": 10,
                "filter": {
                    "product-objectId": data.selectedId
                },
                "productFilter": {},
                "vendorFilter": {},
                "excludeField": {},
                "columnName": "createdAt",
                "columnValue": -1
            }
        )
    }

}


function unverifiedPriceProducts(data) {
    return (
        {
            "pageNo": 1,
            "size": data.size ? data.size : 12,
            "sortFilter": {
                "vendors.updated_at": -1
            },
            "filter": {
                "vendors": {
                    "$elemMatch": {
                        "$and": [
                            {
                                vActive: { $exists: true }
                            },
                            {
                                vActive: { $ne: "REJECT" }
                            },
                            {
                                vActive: "ACTIVE"
                            },
                            {
                                prSts: { $exists: false }
                            }
                        ]
                    }
                }
            },
            "excludeField": {}
        }
    )
}

// Payment related
export function getOrderData(data, dates) {
    if (dates) {
        return ({
            "pageNo": data.pageNo,
            "size": 15,
            "filter": {
                // "products.vendorDetails._id": localStorage.getItem("userId"),
                "from-orderPlaceDate": dates.from + 'T00:00:00',
                "to-orderPlaceDate": dates.to + 'T23:59:59'
            }
        })
    }
    else {
        return ({
            "pageNo": data.pageNo,
            "size": 15,
            "filter": {
                // "products.vendorDetails._id": localStorage.getItem("userId")
            }
        })
    }
}


//    Search products

export function searchAllPros(data) {
    return (
        {
            "pageNo": data.pageNo,
            "size": 15,
            "filter": {
                "adminApproval": true,
                "metaInformation.keywords": data.search
            },
            "sortFilter": {
                "quantity": -1,
                "displayActualPrice": 1
            },
            "excludeField": {
                "metaInformation": 0,
                "description": 0
            }
        }
    )
}

export function getOrderSortdata(data) {
    return (
        {
            "pageNo": data.pageNo,
            "size": 15,
            "filter": {
                // "products.vendorDetails._id": localStorage.getItem("userId"),
                ...data.filters
            },
            "sortFilter": data.sortFilter || { "_id": -1 }
        }
    )
}

// settlements
export function getSettlementData(data) {
    return (
        {
            "pageNo": data.pageNo || 1,
            "size": data.size || 15,
            "filter": {
                // "vendorDetails._id": localStorage.getItem("userId"),
                ...data.filters
            },
            "sortFilter": data.sortFilter || { "_id": -1 }
        }
    )
}

// Fetch opportunity
export function fetchOpportunityData(data) {
    return (
        {
            "pageNo": data.pageNo,
            "size": data.size ? data.size : 12,
            "filter": {
                ...data.filters
            },
            "excludeField": {},
            "sortFilter": data.sortFilter ? data.sortFilter :  { "_id": -1 },
            "productId": data?.productId,//SL-675
            "searchIds": data?.searchIds//SL-675
        }
    )
}

//<Start-Here> Action Required Issue | Ticket : SL-968
/**
 * Create the Action Required Filter
 * @param {*} data 
 * @returns 
 */
export function actionRequiredFilter(data) {
    return (
        {
            "pageNo": data.pageNo,
            "size": data.size ? data.size : 12,
            "sortFilter": {
                "vendors.updated_at": -1
            },
            "filter": {
                ...data.filters,
                "vendors": {
                    "$elemMatch": {
                        //vActive: { $exists: true,  $ne: "REJECT" },
                        active : true,
                        ...data.prStatus,
                        ...data.hsnFilter
                    }
                }
            },
            "excludeField": {},
            "fieldFilters": buildInventoryFieldFilters(data?.fieldFilters),
            "selectFields": buildInventorySelectFields(data?.selectFields),
            "productId": data?.productId,//SL-675
            "searchIds": data?.searchIds//SL-675
        }
    )
}
/**
 * Create the Weight Verification Filter
 * @param {*} data 
 * @returns 
 */
export function weightVerificationFilter(data) {
    const mConditions =  [
                            /*{
                                vActive: { $exists: true }
                            },
                            {
                                vActive: { $ne: "REJECT" }
                            },*/
                            {
                                active : true,
                            },
                            {
                                ...data.weightStatus
                            },
                            // l1-2319 (2-9-26)
                            /*{
                                ...data.hsnFilter
                            }*/
                        ];
    if(data?.hsnFilter)
        mConditions.push({...data.hsnFilter})
    return (
        {
            "pageNo": data.pageNo,
            "size": data.size ? data.size : 12,
            "sortFilter": {
                "vendors.updated_at": -1
            },
            "filter": {
                ...data.filters,
                "vendors": {
                    "$elemMatch": {
                        "$and": mConditions
                    }
                }
            },
            "excludeField": {},
            "fieldFilters": buildInventoryFieldFilters(data?.fieldFilters),
            "selectFields": buildInventorySelectFields(data?.selectFields),
            "productId": data?.productId,//SL-675
            "searchIds": data?.searchIds//SL-675
        }
    )
}
/**
 * Create Active Product FIlter
 * @param {*} data 
 * @returns 
 */
export function activeProductFilter(data) {

    const mConditions = [
        data.status,
        data.stockSts,
        data.prStatus,
        data.weightStatus,
        data.hsnFilter,
        data.saleFilter,
    ].filter(
        (item) => item && Object.keys(item).length > 0
    );

    return {
        pageNo: data.pageNo,
        size: data.size ? data.size : 12,

        sortFilter: {
            "vendors.updated_at": -1
        },

        filter: {
            ...data.filters,
            vendors: {
                $elemMatch: {
                    $and: mConditions
                }
            }
        },

        excludeField: {},

        fieldFilters: buildInventoryFieldFilters(data?.fieldFilters),

        selectFields: buildInventorySelectFields(data?.selectFields),

        productId: data?.productId,

        searchIds: data?.searchIds
    };
}
/**
 * Create Out of Stock Product FIlter
 * @param {*} data 
 * @returns 
 */
export function outOfStockProductFilter(data) {
    const mConditions = [
        
                            {
                                ...data.status
                            },
                            {
                                ...data.stockSts
                            },
                            {
                                ...data.prStatus
                            },
                            {
                                ...data.weightStatus
                            },
                            /*{
                                ...data.hsnFilter
                            },*/
                            
                        
    ];
    if(data?.hsnFilter)
        mConditions.push({...data.hsnFilter});
    return (
        {
            "pageNo": data.pageNo,
            "size": data.size ? data.size : 12,
            "sortFilter": {
                "vendors.updated_at": -1
            },
            "filter": {
                ...data.filters,
                "vendors": {
                    "$elemMatch": {
                        "$and": mConditions
                    }
                }
            },
            "excludeField": {},
            "fieldFilters": buildInventoryFieldFilters(data?.fieldFilters),
            "selectFields": buildInventorySelectFields(data?.selectFields),
            "productId": data?.productId,//SL-675
            "searchIds": data?.searchIds//SL-675
        }
    )
}
//<End-Here> Action Required Issue | Ticket : SL-968

/**
 * Filter for Blocked Products
 * This function should be added to your apidataField.js file
 * 
 * Purpose: Fetch products that have been blocked (made inactive) in the last 30 days
 */

/**
 * Add this function to your apidataField.js file
 * This follows the same pattern as weightVerificationFilter and other filters
 */

export function blockedProductsFilter(data) {
  return {
    pageNo: data.pageNo || 1,
    size: data.size || 12,
  };
}

//get vendor price request filter
export function getVPriceReqsFilter(data) {
    return (
        {
            "pageNo": data.pageNo,
            "size": data.size ? data.size : 12,
            "filter": data.filter,
            "productFilter": {
                "adminApproval": true,
                "_id": data.product,
                "vendors": {
                    "$elemMatch": {
                        vendor_id: localStorage.getItem("vendorId"),
                        active: true,
                        $or: [
                            {
                                $and: [
                                    {
                                    $or: [
                                        { combination: { $exists: false } },
                                        { combination: { $size: 0 } }
                                    ]
                                    },
                                    { prSts: "V_PENDING" }
                                ]
                            },
                            {
                                combination: {
                                    $elemMatch: {
                                        purchase_price: { $exists: true, $ne: null },
                                        prSts: "V_PENDING"
                                    }
                                }
                            },
                        ],
                    }
                }
            },
            "sortFilter": data.sortFilter || {"createdAt": -1},
            "from": data.from,
            // "excludeField": {},
            // "productId": data?.productId,
            // "searchIds": data?.searchIds
        }
    )
}

export { draftedProdInitialCount,draftedProducts,newOrders, transferPriceHistory, searchOrdersWebIdFilter, searchOrdersnameWebFilter, inTransitOrders, cancelledOrders, deliveredOrders, unverifiedPriceProducts, searchManufacturers, pendforapprovProducts, sortdateweb, allOrdersWeb, searchOrdersWebId, searchOrdersHist, approvedProducts, orderHistory, pendingProducts, rejectedProducts, pendingFromSellerProducts, categoryProductList, negotiationReq, filterOrdersdate, filterOrdersdatefilter, filterOrdersfilter, searchapprovedProduct, searchOrders, searchNegreq, fetchQA, fetchansQA, fetchunansQA, fetchAllNotifications, searchOrdersWeb, fetchReviewsData, fetchQaPdetail, fetchReviewPdetail, pdetailData, fetchIgnoredQA, pendingFromSellerProductsWithourRejected , approvedProductsOpp,};

